import { ActionReducerMapBuilder } from '@reduxjs/toolkit'
import {
  fetchLoginToken,
  fetchUserdata,
  login,
  logout,
} from '@store/thunk/auth.thunk'
import { AuthState } from '@store/slices/auth.slice'

export const authExtraReducers = (
  builder: ActionReducerMapBuilder<AuthState>
) => {
  builder
    .addCase(fetchUserdata.pending, (state) => {
      state.user = null
      state.loading = true
      state.error = null
    })
    .addCase(fetchUserdata.fulfilled, (state, action) => {
      if (action.payload)
        state.user = {
          username: action.payload.username,
          email: action.payload.email,
          ttl: action.payload.ttl,
        }
      state.loading = false
    })
    .addCase(fetchUserdata.rejected, (state) => {
      state.loading = false
      state.error = 'Přihlášení vypršelo'
    })
    .addCase(login.pending, (state) => {
      state.user = null
      state.loading = true
      state.error = null
    })
    .addCase(login.fulfilled, (state, action) => {
      state.user = {
        username: action.payload.username,
        email: action.payload.email,
        ttl: action.payload.ttl,
      }
      state.loading = false
    })
    .addCase(login.rejected, (state) => {
      state.loading = false
      state.error = 'Přihlášení selhalo'
    })
    .addCase(fetchLoginToken.pending, (state) => {
      state.loading = true
      state.error = null
    })
    .addCase(fetchLoginToken.fulfilled, (state) => {
      state.loading = false
    })
    .addCase(fetchLoginToken.rejected, (state) => {
      state.loading = false
      state.error = 'Není možné zajistit přihlašovací klíč'
    })
    .addCase(logout.pending, (state) => {
      state.user = null
      state.loading = true
      state.error = null
    })
    .addCase(logout.fulfilled, (state) => {
      state.loading = false
      state.user = null
    })
    .addCase(logout.rejected, (state) => {
      state.loading = false
    })
}
